import { useTheme } from '@cdl/heartbeat-react';
import { useSelector } from 'react-redux';
import { episodeMeasurementRangeSelector } from '../../episodeMeasurement/selectors/episode-measurement.selectors';
import { isToolActiveSelector } from '../../tool/selectors/tool.selectors';
import { Tool } from '../../tool/utils/tool.utils';
import { useParentOnsetsSelector } from '../selectors/scatter.selectors';

export const usePointColor = () => {
  const theme = useTheme();
  const [start, end] = useSelector(episodeMeasurementRangeSelector);
  const isRulerActive = useSelector(
    isToolActiveSelector(Tool.episodeMeasurement),
  );
  const isParentHolterView = useSelector(useParentOnsetsSelector);
  return (point: number) => {
    return point > start && point < end && isRulerActive && !isParentHolterView
      ? theme.colors.primary[500]
      : theme.colors.neutral[900];
  };
};
